import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSelectChange } from '@angular/material/select';
import { Fingerprint } from 'src/app/core/interfaces/fingerprint';
import { LastPointLocation } from 'src/app/core/interfaces/lastPointLocation';
import { Utils } from 'src/app/core/resources/utils';
interface tripAnomalies {
  id: string
  lat: number
  lng: number
  data: Data
}
interface Data {
  key: string
  anomaly: string
  fingerprint: Fingerprint
  fromWeb: boolean
  observation: string
}

@Component({
  selector: 'app-filter-tracking-reports',
  templateUrl: './filter-tracking-reports.component.html',
  styleUrls: ['./filter-tracking-reports.component.scss']
})
export class FilterTrackingReportsComponent {
  @Input() tripAnomalies: tripAnomalies[] = [];
  @Input() lastPointLocations: LastPointLocation[] = [];
  @Input() typeTrackingSelected: string = 'Todos';
  @Output() emitFilteredHistoryNoveltyPoints: EventEmitter<tripAnomalies[] | LastPointLocation[]> = new EventEmitter<tripAnomalies[] | LastPointLocation[]>();
  @Output() emitTypeTrackingSelected: EventEmitter<string> = new EventEmitter<string>();
  filteredHistoryNoveltyPoints: tripAnomalies[] | LastPointLocation[] = [];
  typeTrackingValue: FormControl = new FormControl('Todos');
  typesTracking: string[] = ['Todos', 'Gps', 'Manuales'];
  readonly ORDER_RECENT_FIRST = 'Más recientes primero';
  readonly ORDER_OLDEST_FIRST = 'Más antiguos primero';
  orderTrackingValue: FormControl = new FormControl(this.ORDER_RECENT_FIRST);
  orderTrackingOptions: string[] = [this.ORDER_RECENT_FIRST, this.ORDER_OLDEST_FIRST];
  constructor(
    private utils: Utils
  ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.typeTrackingSelected && this.typeTrackingSelected !== this.typeTrackingValue.value) {
      this.typeTrackingValue.setValue(this.typeTrackingSelected || 'Todos', { emitEvent: false });
    }
    if (changes.tripAnomalies || changes.lastPointLocations) this.filterHistoryNoveltyPoints();
  }

  onSelectionChange($event: MatSelectChange): void {
    if (!$event || !$event.value) return;
    this.typeTrackingSelected = $event.value;
    this.emitTypeTrackingSelected.emit(this.typeTrackingSelected);
    this.filterHistoryNoveltyPoints($event.value);
  }

  onOrderSelectionChange($event: MatSelectChange): void {
    if (!$event || !$event.value) return;
    this.filterHistoryNoveltyPoints();
  }

  private filterHistoryNoveltyPoints(filterType: string = this.typeTrackingSelected || this.typeTrackingValue.value || 'Todos'): void {
    this.filteredHistoryNoveltyPoints = [];
    if (this.tripAnomalies && this.tripAnomalies.length)
      this.filteredHistoryNoveltyPoints = this.filterData(this.tripAnomalies, 'data.fingerprint.userId', filterType);
    else if (this.lastPointLocations && this.lastPointLocations.length)
      this.filteredHistoryNoveltyPoints = this.filterData(this.lastPointLocations, 'fingerprint.userName', filterType);
    this.filteredHistoryNoveltyPoints = this.applyOrder(this.filteredHistoryNoveltyPoints as tripAnomalies[]);
    this.emitFilteredHistoryNoveltyPoints.emit(this.filteredHistoryNoveltyPoints);
  }

  private applyOrder<T>(data: T[]): T[] {
    if (!data || !data.length) return data;
    if (this.orderTrackingValue.value === this.ORDER_RECENT_FIRST)
      return data.slice().reverse();
    return data;
  }

  private filterData<T>(data: T[], userIdPath: string, filterType: string): T[] {
    return data.filter(item => {
      let userId = this.utils.getNestedValue(item, userIdPath);
      if (!userId) return false;
      userId = userId.toLowerCase();
      const isGps = ['satrack', 'monitorhub', 'smartelock', 'gps monitoring system', 'system'].includes(userId);
      switch (filterType) {
        case 'Gps':
          return isGps;
        case 'Manuales':
          return !isGps;
        default:
          return true;
      }
    });
  }


}
